<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height pa-0"
        fluid
        :style="`background-image: url('${backgroundImage}'); background-position: center center; background-size: cover;`"
      >
        <v-col offset-sm="1" sm="10">
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6">
              <v-card class="elevation-12">
                <v-col class="d-flex justify-center pt-12">
                 <v-avatar size="400" max-height="60px" tile>
                    <v-img :src="logoImage" height="100%" contain />
                  </v-avatar>
                </v-col>
                <v-card-title class="d-flex justify-center pt-0">
                  <h5 class="text--disabled font-weight-light">
                    Health Check
                  </h5>
                </v-card-title>
                <v-card-text>
                    <v-col cols="12">
                      <v-btn @click="healthCheck"
                             block
                             color="primary">Executar Teste</v-btn>
                    </v-col>
                    <v-col cols="12" style="height: 106px">
                      <v-alert v-show="retorno.response" :type="retorno.sucesso ? 'success' : 'error'" class="mt-3" text>
                        {{ retorno.response }}
                      </v-alert>
                      <br />
                      <router-link
                      to="/"
                      class="font-weight-medium caption text-decoration-none"
                      >Voltar ao login</router-link
                    >
                    </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  metaInfo: {
    title: 'Health Check'
  },
  props: {
    logoImage: { type: String, default: require('shared/images/svg/logo-black.svg') },
    backgroundImage: {
      type: String,
      default: require('shared/images/svg/background.svg')
    }
  },
  data () {
    return {
      retorno: { sucesso: false, response: null }
    }
  },
  methods: {
    healthCheck () {
      const th = this

      th.$api.HealthCheck.Test().then(response => {
        if (th.$api.UI.PostLoadData(response)) {
          th.$set(th, 'retorno', { sucesso: true, response: 'API Acessível - Sucesso' })
        } else {
          th.$set(th, 'retorno', { sucesso: false, response: response.error || 'API Inacessível' })
        }
      })
    }
  }
}
</script>
